export const FREE_TRY_MODAL_SHOW_AGAGIN_KEY = 'FREE_TRY_MODAL_SHOW_AGAGIN'
